import React from "react";
import { useMutation } from "@apollo/client";
import { TOGGLE_DARKMODE } from "../graphql/gqlUser";
import { useContext, useEffect } from "react";
import { UserContext } from "../contexts/userContext";
import { SnackbarContext } from "../contexts/snackbarContext";
import { T } from "../components/T";

export const useDarkmode = () => {
  const { user } = useContext(UserContext);
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);
  const [toggleDarkmodeMutation] = useMutation(TOGGLE_DARKMODE);
  const isDarkmode =
    user.id !== ""
      ? user.darkmode
      : localStorage.getItem("darkmode") === "true";

  const toggleDarkmode = () => {
    const newIsDarkmode = !isDarkmode;
    localStorage.setItem("darkmode", newIsDarkmode.toString());

    toggleDarkmodeMutation({ variables: { darkmode: newIsDarkmode } })
      .then(() => {
        openSuccessSnackbar(
          newIsDarkmode ? (
            <T str="Darkmode enabled" />
          ) : (
            <T str="Darkmode disabled" />
          )
        );
      })
      .catch((error: Error) => {
        openErrorSnackbar(error.message || <T str="Something went wrong" />);
      });
  };

  useEffect(() => {
    // The following is required to access the theme in css files
    document.documentElement.setAttribute(
      "data-theme",
      isDarkmode ? "dark" : "light"
    );
  }, [isDarkmode]);

  return { isDarkmode, toggleDarkmode };
};
